/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { companyTrackerInitiativeRoutes } from './CompanyTrackerInitiativeRoute';
import Downloads from '../../components/downloads';
import CustomReportsRoot from '../../components/downloads/CustomReportsRoot';

const DownloadsRoute = () => {

  return <>
    <Switch>
      <Route path={companyTrackerInitiativeRoutes.DOWNLOADS_CUSTOM.path} >
        <CustomReportsRoot />
      </Route>

      <Route>
        <Downloads />
      </Route>
    </Switch>
  </>
}

export default DownloadsRoute;
